<template>
  <el-dialog
    top="50px"
    width="500px"
    :title="item ? 'Sửa tổ chức' : 'Thêm tổ chức'"
    :visible="visible"
    :show-close="!callingAPI"
    append-to-body
    @close="$emit('close')"
  >
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      size="small"
    >
      <el-row
        label-position="top"
        type="flex"
        align="start"
        class="flex-wrap"
        :gutter="12"
      >
        <el-col
          :lg="24"
          :span="24"
        >
          <el-form-item
            prop="code"
            label="Mã tổ chức"
          >
            <el-input
              v-model="form.code"
              placeholder="Nhập mã"
            />
          </el-form-item>
        </el-col>
        <el-col
          :lg="24"
          :span="24"
        >
          <el-form-item
            prop="summary"
            label="Tên tổ chức"
          >
            <el-input
              v-model="form.summary"
              placeholder="Nhập tên"
            />
          </el-form-item>
        </el-col>
        <el-col
          :lg="24"
          :span="24"
        >
          <el-form-item
            prop="priority"
            label="Loại tổ chức"
          >
            <el-select
              v-model="form.priority"
              placeholder="Chọn loại"
              class="w-100"
              filterable
            >
              <el-option
                label="Supper Admin"
                :value="0"
              />
              <el-option
                label="Admin"
                :value="1"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          :lg="24"
          :span="24"
        >
          <el-form-item
            prop="description"
            label="Mô tả"
          >
            <el-input
              v-model="form.description"
              placeholder="Nhập mô tả"
            />
          </el-form-item>
        </el-col>
        <el-col
          :lg="24"
          :span="24"
        >
          <el-form-item
            prop="avatar_url"
            label="Logo"
          >
            <el-input
              v-model="form.avatar_url"
              placeholder="Nhập link logo"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        :disabled="callingAPI"
        size="medium"
        @click="$emit('close')"
        >Đóng</el-button
      >
      <el-button
        type="primary"
        :loading="callingAPI"
        size="medium"
        @click="handleConfirm"
        >Lưu</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";
import { notification } from "@/utils/common";
import organizationServices from "@/services/organization";

export default {
  name: "DataFormPopup",
  props: {
    item: Object,
    visible: Boolean,
  },
  data() {
    return {
      loading: false,
      form: {
        code: "",
        summary: "",
        description: "",
        avatar_url: "",
      },
      callingAPI: false,
    };
  },
  computed: {
    ...mapActions("organization", ["setAllOrganizations"]),
    isCreate() {
      return !this.item || !this.item.id;
    },
    payloadData() {
      if (this.isCreate) {
        return this.form
      }
      return {
        ...this.item,
        ...this.form
      };
    },
    rules() {
      const result = {
        summary: [
          {
            required: true,
            message: `Tên tổ chức là trường bắt buộc.`,
            trigger: ["blur", "change"],
          },
        ],
      };
      return result;
    },
  },
  beforeMount() {
    this.loadFormData();
  },
  methods: {
    loadFormData() {
      if (this.item) {
        this.form = {
          code: this.item.code,
          avatar_url: this.item.avatar_url,
          summary: this.item.summary,
          description: this.item.description,
          priority: this.item.priority,
        };
      } else {
        this.form = {
          code: "",
          avatar_url: "",
          summary: "",
          description: "",
          priority: 1,
        };
      }
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.callingAPI = true;
          organizationServices[!this.isCreate ? "update" : "create"](
            this.payloadData
          )
            .then(() => {
              this.callingAPI = false;
              this.$emit("reload");
              this.setAllOrganizations();
              notification(
                this,
                "success",
                !this.isCreate ? "update" : "create",
                "tổ chức"
              );
              this.$emit("close");
            })
            .catch(() => {
              this.callingAPI = false;
              notification(
                this,
                "error",
                !this.isCreate ? "update" : "create",
                "tổ chức"
              );
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
